import React, { useEffect, useState } from 'react'
import { Bar } from 'react-chartjs-2'
import { fetchDataDaily } from '../api'

function Chart({data:{confirmed,recovered,deaths}, country}) {
    
    const [dailyData, setDailyData] = useState([])
    useEffect(()=>{
       const fetchAPI = async()=>{
        setDailyData(await fetchDataDaily())
       } 
       fetchAPI()
    },[])

    const LineChart =(
        dailyData.length && 
        <Bar data={{
            labels:dailyData.map(({date})=> date),
            datasets:[{
                data:dailyData.map(({confirmed})=> confirmed),
                label:"Infected",
                borderColor:"yellow",
                backgroundColor:"#63b3ed",
                fill:true
            },{
                data:dailyData.map(({deaths})=> deaths),
                label:"Deaths",
                borderColor:"red",
                backgroundColor:"#fc8181",
                fill:true
            }]
        }}
        
        >

        </Bar>
        );
    
    const BarChart = confirmed 
    ?
    <Bar data={{
            labels:["Infected","Recovered","Deaths"],
            datasets:[
                {
                    label:"People",
                    backgroundColor:["#63b3ed","#68d391","#fc8181"],
                    data:[confirmed.value,recovered.value,deaths.value]
                }
            ]
        }}
        options={{
                legend:{display:false},
                title:{display:true, text:`Current state in ${country}`}
            }}
        >

        </Bar>:null; 

    return (
        <div className="my-10">
            {country ? BarChart: LineChart}
        </div>
    )
}

export default Chart
